jQuery(document).ready(function(){$("ul.tabs").each(function(){var t,e,a=$(this).find("a");e=$((t=a.first().addClass("active")).attr("href")),a.not(":first").each(function(){$($(this).attr("href")).hide()}),$(this).find("a").click(function(a){return t.removeClass("active"),e.hide(),t=$(this),e=$($(this).attr("href")),t.addClass("active"),e.show(),!1})}),980>$(window).width()&&$(".fordesktop_productbelow .producttab_fordesktop .full-tab-section").remove(),$(".toggle").click(function(t){t.preventDefault();var e=$(this);e.next().hasClass("shows")?(e.next().removeClass("shows"),e.next().slideUp(350)):(e.parent().parent().find(".tabsingle_wr .inner").removeClass("shows"),e.parent().parent().find(".tabsingle_wr .inner").slideUp(350),e.next().toggleClass("shows"),e.next().slideToggle(350))})}),$("body").on("click",'[data-action="popup-close"]',function(){$(this).parents(".modal").hide()}),$(document).on("click",".add_to_cart",function(){var t=$(this).attr("data-var_id");t&&$.ajax({type:"POST",url:"/cart/add.js",dataType:"json",data:{id:t,quantity:1},success:function(){}})});var modal=document.getElementById("myModal"),btn=document.getElementById("myBtn"),span=document.getElementsByClassName("close")[0],conti=document.getElementById("cart_added__close");btn&&(btn.onclick=function(){modal.style.display="block"}),$("body").on("click","#cart_added__close",function(){$(this).parents(".modal").hide()}),span.onclick=function(){modal.style.display="none"},window.onclick=function(t){t.target==modal&&(modal.style.display="none")};

// Predictive search loading indicator — attaches to each <predictive-search> element
// without modifying the minified theme.js custom element.
(function () {
  function initWrSearchLoading(searchEl) {
    var input = searchEl.querySelector('input[name="q"]');
    var results = searchEl.querySelector('#predictive-search');
    if (!input || !results) return;

    // Set loading state when user types a non-empty query
    input.addEventListener('input', function () {
      if (input.value.trim().length > 0) {
        results.setAttribute('data-wr-loading', 'true');
      } else {
        results.removeAttribute('data-wr-loading');
      }
    });

    // Clear loading state once theme.js injects content (childList mutation)
    new MutationObserver(function () {
      results.removeAttribute('data-wr-loading');
    }).observe(results, { childList: true });
  }

  function attachAll() {
    document.querySelectorAll('predictive-search').forEach(initWrSearchLoading);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }
})();